export type ItineraryMarkerRole = "start" | "end" | "stop" | "from" | "to";

/** Compact badge matching Start / Stop / End roles on cards and map pins. */
export const getItineraryMarkerBadge = (
  role: ItineraryMarkerRole,
  roleLabel?: string
): string => {
  if (role === "start" || role === "from") {
    return "A";
  }

  if (role === "end" || role === "to") {
    return "B";
  }

  const match = roleLabel?.match(/(\d+)/);
  if (match) {
    return match[1];
  }

  return "•";
};
